export default "__VITE_ASSET__791rVgfTaL1uBVfLyzDJmw__"